var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"critical-error"},[_c('div',{staticClass:"critical-error__title"},[_vm._v("404")]),_c('div',{staticClass:"critical-error__subtitle"},[_vm._v("Not Found")]),_c('div',{staticClass:"critical-error__text"},[_vm._v("Такой страницы не существует")])])
}]

export { render, staticRenderFns }